

/* BEGIN tactical-outlaw-sling-buyer-highlights-20260731 */
;(function () {
  var expected = ["Water-resistant 900D polyester, a durable SBS zipper, and secure KAM buckles support reliable everyday use and quick access to gear.","MOLLE webbing, a hook-and-loop patch area, and a D-ring expand attachment, personalization, shoulder-strap, and small-item carrying options.","A top handle and detachable shoulder strap that stores in the pocket support convenient hand carry, while the main compartment keeps essentials organized."];
  function applyBuyerHighlights() {
    if (window.location.pathname.indexOf('/products/seibertron-tactical-outlaw-sling-pack-molle-multifunctional-day-bag') === -1) return;
    var box = document.querySelector('.auto-product__buyer-fit');
    if (!box) return;
    var items = box.querySelectorAll('li');
    if (items.length < 3) return;
    for (var i = 0; i < 3; i += 1) { if (items[i].textContent !== expected[i]) items[i].textContent = expected[i]; }
  }
  applyBuyerHighlights();
  [80, 250, 800, 1800, 4000].forEach(function (delay) { window.setTimeout(applyBuyerHighlights, delay); });
  new MutationObserver(applyBuyerHighlights).observe(document.documentElement, { childList: true, subtree: true });
})();
/* END tactical-outlaw-sling-buyer-highlights-20260731 */
